import IconError from '@apollo/icons/default/IconError.svg';
import classnames from 'classnames';
import React from 'react';

import { safeCompileMarkdown } from 'src/lib/safeCompileMarkdown';

interface BuildDetailsErrorItemProps {
  error: {
    message: string;
    code?: string | null;
  };
  size?: 'standard' | 'small';
  className?: string;
}

// markdown-to-jsx's typings mistakenly use React.ComponentType rather than React.ElementType
// so we have to make a component instead of just passing `code`
function Code(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  >,
) {
  return <code {...props} />;
}

export const BuildDetailsErrorItem = ({
  error,
  size = 'standard',
  className,
}: BuildDetailsErrorItemProps) => {
  return (
    <div
      className={classnames(
        'w-full border-t border-primary py-4 first:border-t-0',
        size === 'small' ? 'text-sm' : 'text-base',
        className,
      )}
    >
      <div className="flex items-center font-semibold text-error">
        <IconError className="mr-2 items-center text-icon-error" />
        {error.code ?? 'Error'}
      </div>
      <div>
        <code
          className={classnames(
            'ml-6 flex text-left text-secondary',
            size === 'small' ? 'text-xs' : 'text-sm',
          )}
          style={{
            overflowWrap: 'anywhere',
          }}
        >
          {safeCompileMarkdown(error.message, {
            overrides: {
              code: {
                component: Code,
                props: { className: 'text-pink bg-silver' },
              },
            },
          })}
        </code>
      </div>
    </div>
  );
};
